/**主动发货和退货路由 */
export default {
        name: 'goods',
        path: 'goods',
        meta: {title:'主动发货和退货'},
        component: ()=>import('@/pages/index.vue'),
        children:[
            {
                name: 'goods-deliver',
                path: 'deliver',
                meta: { title: '主动发货出库' },
                component: ()=>import('@/pages/goods/deliver.vue')
            },
            {
                name: 'goods-return',
                path: 'return',
                meta: { title: '主动退货入库' },
                component: ()=>import('@/pages/goods/return.vue')
            }
        ]
        
    }